import {
    selectConfiguredSymbolForWidgetOrItsCapsuleContainer,
    selectParentCapsuleContainerConfiguredSymbol,
} from 'widgets/tiles/store/selectors';
import { useWidgetContext } from 'widgets/WidgetContext';
import { useSelector } from 'react-redux';
import State from 'store/State';

export const useSelectConfiguredSymbolForWidgetOrItsCapsuleContainer = () => {
    const { widgetType, widgetKey } = useWidgetContext();

    return useSelector((state: State) =>
        selectConfiguredSymbolForWidgetOrItsCapsuleContainer(state, {
            widgetType,
            widgetKey,
        })
    );
};

export const useSelectParentCapsuleContainerConfiguredSymbol = () => {
    const { widgetKey } = useWidgetContext();
    return useSelector((state: State) =>
        selectParentCapsuleContainerConfiguredSymbol(state, widgetKey)
    );
};
